import { Link } from "react-router-dom";
import { ArrowRight, Eye, Trash2, Server } from "lucide-react";
import { Glossary } from "../Glossary";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { useLanguage } from "../../context/LanguageContext";
import { useHome } from "../../translations/home";
import { WallParticles } from "../WallParticles";
import { DemoCTA } from "./DemoCTA";

const ICONS = [<Eye className="w-5 h-5" />, <Trash2 className="w-5 h-5" />, <Server className="w-5 h-5" />];

const HomeWall = () => {
  const { language } = useLanguage();
  const w = useHome(language).wall;
  const { ref, isRevealed } = useScrollReveal({ threshold: 0.2 });

  return (
    <section id="trust" className="relative border-y border-linec-200 py-20 lg:py-24 bg-[#F4F7FB]" data-testid="wall-section">
      <div className="absolute inset-0 dots-drift-light pointer-events-none opacity-70" aria-hidden="true" />
      <Glossary><div className="wrap-cayus">
        <div className="rule-cobalt mb-5" />
        <p className="mono-cayus text-cobalt-600 mb-4">{w.eyebrow}</p>
        <h2 className="font-bold text-3xl sm:text-4xl text-inkc-800 tracking-[-0.03em] mb-10 max-w-[30ch]">{w.title}</h2>

        <WallParticles />

        <p className="text-[15px] text-inkc-600 leading-relaxed mt-6 max-w-[52rem]" data-testid="wall-note">
          {w.note}
        </p>

        <div ref={ref} className={`grid md:grid-cols-3 gap-5 mt-10 mb-10 stagger-grid ${isRevealed ? "is-in" : ""}`}>
          {w.guarantees.map((g, i) => (
            <div key={i} className="card-lift bg-white border border-linec-300 rounded-xl p-6" data-testid={`guarantee-${i}`}>
              <div className="w-11 h-11 rounded-lg bg-cobalt-50 border border-cobalt-100 text-cobalt-600 flex items-center justify-center mb-4">
                {ICONS[i]}
              </div>
              <h3 className="font-bold text-base text-inkc-800 tracking-[-0.02em] mb-2">{g.t}</h3>
              <p className="text-sm text-inkc-600 leading-relaxed">{g.d}</p>
            </div>
          ))}
        </div>

        <Link
          to="/securite"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-cobalt-600 underline decoration-cobalt-300 underline-offset-4 hover:decoration-cobalt-600 transition-colors mb-10"
          data-testid="wall-security-link"
        >
          {w.link}
          <ArrowRight className="w-4 h-4" />
        </Link>

        <DemoCTA from="wall" variant="ghost" />
      </div></Glossary>
    </section>
  );
};

export default HomeWall;
